/**
 * @param {string} date
 * @return {string}
 */
export const reverseDateFormat = date => date.split('-').reverse().join('-');

/**
 * @param {string} date
 * @return {boolean}
 */
export const dateIsYYYYMMDD = date => /^[0-9]{4}-[0-9]{2}-([0-9]{2})/.test(date);

/**
 * @param {Date} date
 * @return {string}
 */
export const getDutchFormat = date => new Intl.DateTimeFormat('nl-NL', {
	day: '2-digit',
	month: '2-digit',
	year: 'numeric'
}).format(date);

/**
 * @param {string} value
 * @return {boolean}
 */
export const stringIsValidDate = value => !isNaN(Date.parse(value)) && value.match(/^(0[1-9]|1[0-9]|2[0-9]|3[01])-(0[1-9]|1[012])-[0-9]{4}/);
